import yup from "src/validators/yup.Module";

export interface SistemaFiltrarDto {
  subModulo: string | null;
  usuarioId?: string | null;
}

export interface SistemaCadastroDto {
  id: string;
  empresaId: string;
  subModulo: string;
  tipoConfiguracao: string;
  tipoConfiguracaoDescricao: string;
  configuracaoValor: string;
}

export const subModuloOptions = [
  { value: "1", label: "NFCe" },
  { value: "2", label: "NFe" },
];

export enum SubModuloEnum {
  NFCe = "1",
  NFe = "2",
}

export enum TipoConfiguracaoEnum {
  IdToken = "1",
  CSC = "2",
  TipoAmbiente = "3",
  TipoEmissao = "4",
  Serie = "5",
}

export const SistemaFiltrarSchema = yup.object().shape({});
